// AUTO-GENERATED by build/islands/build-islands.mjs — do not edit.

/** @type {Record<string, () => Promise<{ default: import('react').ComponentType<any> }>>} */
export const islandLoaders = {
	demo: () => import('../../templates/modules/demo/demo.mjs'),
	powered_by_rp: () => import('../../templates/modules/powered_by_rp/powered_by_rp.mjs'),
	product_media: () => import('../../templates/modules/product_media/product_media.mjs'),
	rp_ui_smoke: () => import('../../templates/modules/rp_ui_smoke/rp_ui_smoke.mjs'),
};
